import React from "react";
var Isvg = require("../../../vendor/react-inlinesvg");

const ModalHeaderButtons = ({
  dataUID,
  style,
  hideCloseButton,
  showCancelButton,
  showSaveButton,
  cancelCallback,
  saveCallback,
  removeModal,
  className
}) => (
  <span
    key={"modal-header-container"}
    data-uid={dataUID}
    className={"modal-header-container " + className}
    style={style}
  >
    {hideCloseButton && (
      <button className="modal-x noButton" onClick={removeModal}>
        <Isvg src="/img/x_gray.svg" />
        <span className="offScreen">{i18n.t("base.close")}</span>
      </button>
    )}
    {showCancelButton && (
      <button className="modal-cancel noButton" onClick={cancelCallback}>
        <Isvg src="/img/x_gray.svg" />
        <span className="offScreen">{i18n.t("base.cancel")}</span>
      </button>
    )}
    {showSaveButton && (
      <button className="modal-save noButton" onClick={saveCallback}>
        <Isvg src="/img/x_gray.svg" />
        <span className="offScreen">{i18n.t("base.save")}</span>
      </button>
    )}
  </span>
);

export default ModalHeaderButtons;
